// Retrieve Items
export const GET_SECTORS_START = 'GET_SECTORS_START';
export const GET_SECTORS_SUCCESS = 'GET_SECTORS_SUCCESS';
export const GET_SECTORS_FAILURE = 'GET_SECTORS_FAILURE';

export const OPEN_FORM = "OPEN_FORM";
export const CLOSE_FORM = "CLOSE_FORM";

// Create Project sectors
export const CREATE_PROJECT_SECTOR_START = 'CREATE_PROJECT_SECTOR_START';
export const CREATE_PROJECT_SECTOR_SUCCESS = 'CREATE_PROJECT_SECTOR_SUCCESS';
export const CREATE_PROJECT_SECTOR_FAILURE = 'CREATE_PROJECT_SECTOR_FAILURE';

